<section fxFlex fxLayout="column" fxLayoutGap="10px">
  <iot-platform-ui-detail-popup-section-header headerTitle="{{ 'IOT_DICTIONARY.site' | translate }}"></iot-platform-ui-detail-popup-section-header>
  @if (loaded()) {
    <iot-platform-ui-detail-site-card (selectSite)="selectSite.emit(site())" [site]="site()" />
  } @else {
    <iot-platform-ui-card-loader [backgroundClass]="'mv-detail-card h-140'" />
  }
</section>
